import $ from 'jquery';
import moment from 'moment';

moment.locale('el');

/**
 * @param {boolean} island
 * @param {boolean} mayToAugust
 * @return {moment.Duration}
 */
const getMinimumDuration = (island, mayToAugust) => {
    return island && mayToAugust ?
        moment.duration(30, 'minutes') :
        moment.duration(3, 'hours');
};

/**
 * @param {boolean} island
 * @param {boolean} mayToAugust
 * @return {number}
 */
const getMinimumPrice = (island, mayToAugust) => {
    return island && mayToAugust ? 36 : 82;
};

/**
 * @param {JQuery} $el
 * @return {boolean}
 */
const isIsland = $el => $el.find(':selected').data('island');

/**
 * @param {moment.Moment} date
 */
const isMayToAugust = (date) => {
    return [3, 4, 5, 6, 7, 8, 9].includes(date.month());
};

/**
 * @param {JQuery} $startingPoint
 * @param {JQuery} $helpBlock
 * @param {daterangepicker} startedAt
 * @param {daterangepicker} endedAt
 */
const updateEndedAt = ($startingPoint, $helpBlock, startedAt, endedAt) => {
    let island = isIsland($startingPoint) || false;
    let mayToAugust = isMayToAugust(startedAt.startDate);
    let minimumDuration = getMinimumDuration(island, mayToAugust);
    let minimumEndDate = startedAt.startDate.clone().add(minimumDuration);
    let endDate = moment.max(endedAt.startDate, minimumEndDate);

    endedAt.setStartDate(endDate);
    endedAt.minDate = minimumEndDate;
    $(endedAt.element).val(endDate.format('DD/MM/YYYY HH:mm'));

    $helpBlock.find('strong').text(minimumDuration.humanize());
};

/**
 * @param {JQuery} $startingPoint
 * @param {JQuery} $helpBlock
 * @param {daterangepicker} startedAt
 * @param {JQuery} $price
 */
const updatePrice = ($startingPoint, $helpBlock, startedAt, $price) => {
    let island = isIsland($startingPoint) || false;
    let mayToAugust = isMayToAugust(startedAt.startDate);
    let minimumPrice = getMinimumPrice(island, mayToAugust);
    let price = Math.max(parseFloat($price.val() || 0), minimumPrice);

    $price.attr('min', minimumPrice);
    $price.val(price);

    $helpBlock.find('strong').text('€ ' + minimumPrice);
};

$(() => {
    const $collapseLesseeNatural = $('.collapse-lessee-natural').collapse({ toggle: false });
    const $collapseLesseeLegal = $('.collapse-lessee-legal').collapse({ toggle: false });

    $('#lessee_natural, #lessee_legal').on('change', (e) => {
        $collapseLesseeNatural.collapse(e.currentTarget.value === 'natural' ? 'show' : 'hide');
        $collapseLesseeNatural.prop('disabled', e.currentTarget.value === 'legal');
        $collapseLesseeLegal.collapse(e.currentTarget.value === 'legal' ? 'show' : 'hide');
        $collapseLesseeLegal.prop('disabled', e.currentTarget.value === 'natural');
    });

    const $startingPoint = $('[name=starting_point_id]');
    const startedAt = $('[name=started_at]').data('daterangepicker');
    const endedAt = $('[name=ended_at]').data('daterangepicker');
    const $endedAtHelpBlock = $('#endedAtHelpBlock');

    const $price = $('[name=price]');
    const $priceHelpBlock = $('#priceHelpBlock');

    if ($startingPoint.length && startedAt && endedAt) {
        updateEndedAt($startingPoint, $endedAtHelpBlock, startedAt, endedAt);

        $startingPoint.on('change', () => {
            updateEndedAt($startingPoint, $endedAtHelpBlock, startedAt, endedAt);
        });

        $(startedAt.element).on('change apply.daterangepicker', (e) => {
            updateEndedAt($startingPoint, $endedAtHelpBlock, startedAt, endedAt);
            updatePrice($startingPoint, $priceHelpBlock, startedAt, $price);
        });
    }

    if ($startingPoint.length && startedAt && $price.length) {
        updatePrice($startingPoint, $priceHelpBlock, startedAt, $price);

        $startingPoint.on('change', () => {
            updatePrice($startingPoint, $priceHelpBlock, startedAt, $price);
        });

        $(startedAt.element).on('change apply.daterangepicker', (e) => {
            updatePrice($startingPoint, $priceHelpBlock, startedAt, $price);
        });
    }
});
